import { render, staticRenderFns } from "./study-title.vue?vue&type=template&id=5d8f5265&scoped=true&"
import script from "./study-title.vue?vue&type=script&lang=ts&"
export * from "./study-title.vue?vue&type=script&lang=ts&"
import style0 from "./study-title.vue?vue&type=style&index=0&id=5d8f5265&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f5265",
  null
  
)

export default component.exports